import { useEffect, useState, useCallback } from 'react';
import { APP_VERSION, CHANGELOG, nouveautesDepuis } from '../../changelog';
import NouveautesModal from '../common/NouveautesModal';

/**
 * NouveautesAuto — pilote l'affichage du modal "Nouveautés".
 *
 * Deux déclenchements :
 *   1. AUTOMATIQUE après une vraie mise à jour : si la version vue par le
 *      client (mémorisée localement) diffère d'APP_VERSION, on ouvre le
 *      modal avec les changements survenus depuis sa dernière visite.
 *      → Première visite : on mémorise la version sans rien afficher
 *        (on n'embête pas un nouvel utilisateur avec l'historique).
 *   2. MANUEL : clic sur "Quoi de neuf ?" (pied de page) → event global
 *      `sv:open-nouveautes` → on affiche les dernières entrées.
 *
 * À la fermeture, on enregistre APP_VERSION comme "version vue".
 */

const VERSION_KEY = 'sv_version_vue';
const NB_ENTREES_MANUEL = 3; // combien de versions montrer en ouverture manuelle

export default function NouveautesAuto() {
  const [entries, setEntries] = useState(null); // null = modal fermé

  // ── 1. Détection automatique après mise à jour ──────────────────────────
  useEffect(() => {
    let vue = null;
    try { vue = localStorage.getItem(VERSION_KEY); } catch {}

    if (!vue) {
      // Première visite (ou stockage indisponible) : on mémorise, sans afficher.
      try { localStorage.setItem(VERSION_KEY, APP_VERSION); } catch {}
      return;
    }
    if (vue !== APP_VERSION) {
      const nouv = nouveautesDepuis(vue);
      if (nouv.length) setEntries(nouv);
    }
  }, []);

  // ── 2. Ouverture manuelle ("Quoi de neuf ?") ────────────────────────────
  useEffect(() => {
    const open = () => setEntries(CHANGELOG.slice(0, NB_ENTREES_MANUEL));
    window.addEventListener('sv:open-nouveautes', open);
    return () => window.removeEventListener('sv:open-nouveautes', open);
  }, []);

  const close = useCallback(() => {
    try { localStorage.setItem(VERSION_KEY, APP_VERSION); } catch {}
    setEntries(null);
  }, []);

  if (!entries) return null;
  return <NouveautesModal entries={entries} onClose={close} />;
}
